export default __webpack_public_path__ + "static/media/step_A_EN.a9157439.png";